// extracted by mini-css-extract-plugin
module.exports = {"svgContainer":"Waveform-modulesvgContainerpX1","min":"Waveform-modulemin3Z5","spinnerIcon":"Waveform-modulespinnerIcon2Wp"};